module.exports = __webpack_public_path__ + "img/noti-unsuccess2.5a5b6fa8.svg";